import React, { useContext } from 'react'
import Stack from '@mui/material/Stack'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'
import {
  Autocomplete,
  Box,
  FormControl,
  FormControlLabel,
  FormHelperText,
  InputLabel,
  Switch,
  TextField,
} from '@mui/material'
import PMHxOptions from './PMHxOptions'
import commonAllergies from './allergies'
import { EPCRContext } from '../EPCR'
import commonPrescribedMedicinesUK from './drugs'
import EPCRCard from '../../../../components/Cards/EPCRCard'
import NextButton from '../NextButton'

const PMHx = () => {
  const { formValues, handleChange } = useContext(EPCRContext)
  return (
    <Stack gap={2}>
      <EPCRCard>
        <Typography variant="title2">Past Medical History</Typography>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Autocomplete
              options={PMHxOptions}
              value={formValues?.pmhx?.diseases ?? []}
              multiple
              getOptionLabel={(params) => params.disease}
              groupBy={(params) => params.category}
              freeSolo
              onChange={(e, value) =>
                handleChange({
                  moduleName: 'pmhx',
                  field: 'diseases',
                  value: value.reduce((accumulator, x) => {
                    if (typeof x === 'object') {
                      accumulator.push(x)
                    } else {
                      accumulator.push({
                        category: 'custom',
                        disease: x,
                      })
                    }
                    return accumulator
                  }, []),
                })
              }
              renderInput={(props) => (
                <TextField
                  {...props}
                  label="Medical Conditions"
                  inputProps={{
                    ...props.inputProps,
                    inputMode: 'text',
                    enterKeyHint: 'done', // Or "enter" or "newline"
                  }}
                />
              )}
            />
          </Grid>
          <Grid item xs={12}>
            <Autocomplete
              options={['No Allergies', ...commonAllergies.sort()]}
              value={formValues?.pmhx?.allergies ?? []}
              multiple
              freeSolo
              onChange={(e, value) =>
                handleChange({
                  moduleName: 'pmhx',
                  field: 'allergies',
                  value,
                })
              }
              renderInput={(props) => (
                <TextField {...props} label="Allergies" />
              )}
            />
          </Grid>
          <Grid item xs={12}>
            <Autocomplete
              options={commonPrescribedMedicinesUK.sort()}
              value={formValues?.pmhx?.medicines ?? []}
              multiple
              freeSolo
              onChange={(e, value) =>
                handleChange({
                  moduleName: 'pmhx',
                  field: 'medicines',
                  value,
                })
              }
              renderInput={(props) => (
                <TextField
                  {...props}
                  label="Medicines"
                  inputProps={{
                    ...props.inputProps,
                    inputMode: 'text',
                    enterKeyHint: 'done', // Or "enter" or "newline"
                  }}
                />
              )}
            />
          </Grid>
          <Grid item xs={12}>
            <FormControlLabel
              label="SPO2 Scale 2"
              control={
                <Switch
                  checked={formValues?.pmhx?.spo2Scale2 ?? false}
                  onChange={(e) =>
                    handleChange({
                      moduleName: 'pmhx',
                      field: 'spo2Scale2',
                      value: e.target.checked,
                    })
                  }
                />
              }
            />
            <Typography variant="caption">
              Patient has chronic hypercapnic respiratory failure with a
              recommended target SPO2 between 88 - 92% (Used for calculating
              NEWS2 scores)
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Stack gap={1}>
              <TextField
                value={formValues?.pmhx?.socialHx ?? ''}
                onChange={(e) =>
                  handleChange({
                    moduleName: 'pmhx',
                    field: 'socialHx',
                    value: e.target.value,
                  })
                }
                label="Social History"
                autoComplete="off"
                multiline
              />
              <TextField
                value={formValues?.pmhx?.familyHx ?? ''}
                onChange={(e) =>
                  handleChange({
                    moduleName: 'pmhx',
                    field: 'familyHx',
                    value: e.target.value,
                  })
                }
                label="Family History"
                autoComplete="off"
                multiline
              />
            </Stack>
          </Grid>
        </Grid>
      </EPCRCard>
      <NextButton newModule="History" />
    </Stack>
  )
}

export default PMHx
